import Model from './Model';

export default class InvoiceItem extends Model {
    invoice_product_id;
    invoice_product;
    count;
    unit_price;
    vat_percentage;

    static fromJson(json) {
        let instance = super.fromJson(json);
        // Do the required percentages/prices divisions.
        instance.unit_price /= 100;
        instance.vat_percentage /= 10;
        return instance;
    }

    toJson() {
        this.unit_price *= 100;
        this.vat_percentage *= 10;

        const dtoIds = {
            invoice_product_id: this.invoice_product.id,
        };

        return { ...this, ...dtoIds };
    }

}



// WEBPACK FOOTER //
// ./src/models/InvoiceItem.js